/**
 * Class names for `AppBarMenu` components (src/components/AppBar/AppBarMenu/).
 */
export const appBarMenuClassNames = {
  /** Class names used in the `DESKTOP` variant of the `AppBarMenu`. */
  desktop: {
    linksContainer: "appbar-menu__desktop-links-container",
    link: "appbar-menu__desktop-link",
  },
} as const;
